module.exports = __webpack_public_path__ + "media/application/assets/images/background_jumbotron_small-0f2d8e27df9b3247a012fa82d3790e08.jpg";